import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import LogoHero from './components/LogoHero';
import AboutSection from './components/AboutSection';
import TreatmentsOverview from './components/TreatmentsOverview';
import MesoporationSection from './components/MesoporationSection';
import PhilosophySection from './components/PhilosophySection';
import ServicesSection from './components/ServicesSection';
import StudioSection from './components/StudioSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  useScrollAnimation();

  return (
    <>
      <header>
        <Navbar />
      </header>
      <main className="min-h-screen bg-warm-light">
        <LogoHero />
        <AboutSection />
        <TreatmentsOverview />
        <MesoporationSection />
        <PhilosophySection />
        <ServicesSection />
        <StudioSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}